import api from '../api'

export default {
  
  dashboard: async () => {
    return api.get(`api/dashboard`)
  },

 

}
